import React, { useContext } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Footer from './app/footer/Footer';
import Home from './app/Home';
import Login from './app/login/Login';
import ForgotPassword from './app/login/ForgotPassword';
import Header from './app/header/Header';
import PushNotificationPrompt from './app/components/PushNotificationPrompt';
import UserContext from './app/context/UserContext';
import { MobileMenuProvider } from './app/context/MobileMenuContext';
import { Sheet, Box } from '@mui/joy';

const AUTH_FREE_PATHS = ['/login', '/forgot-password'];

const AppContent = () => {
  const location = useLocation();
  const { user } = useContext(UserContext);
  const showPushPrompt = user && !AUTH_FREE_PATHS.includes(location.pathname);

  return (
    <Sheet
      variant="plain"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        bgcolor: 'background.surface',
        m: 0,
        p: 0
      }}
    >
      <Header />
      <Box
        sx={{
          flex: 1,
          width: '100%',
          m: 0,
          p: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Routes>
          <Route path="/*" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Routes>
      </Box>
      <Footer />
      {showPushPrompt && <PushNotificationPrompt />}
    </Sheet>
  );
};

function Router() {
  return (
    <BrowserRouter>
      <MobileMenuProvider>
        <AppContent />
      </MobileMenuProvider>
    </BrowserRouter>
  );
}

export default Router;
